import Data from '../Data';

// Action Types

export const RequestCustomPostFields = 'canny/customPostFields/request';
export const CustomPostFieldsLoaded = 'canny/customPostFields/loaded';
export const CustomPostFieldsError = 'canny/customPostFields/error';

// Actions

function requestCustomPostFields() {
  return {
    timestamp: Date.now(),
    type: RequestCustomPostFields,
  };
}

function customPostFieldsLoaded(customPostFields) {
  return {
    customPostFields,
    timestamp: Date.now(),
    type: CustomPostFieldsLoaded,
  };
}

function customPostFieldsError(error) {
  return {
    error,
    timestamp: Date.now(),
    type: CustomPostFieldsError,
  };
}

// Action Creators

function fetchCustomPostFields() {
  return (dispatch, getState) => {
    const { cookies } = getState();
    return Data.fetch(
      {
        customPostFields: {
          query: Data.queries.customPostFields,
        },
      },
      cookies,
      (error, data) => {
        if (error) {
          return dispatch(customPostFieldsError(error));
        } else {
          return dispatch(customPostFieldsLoaded(data.customPostFields));
        }
      }
    );
  };
}

export function loadCustomPostFields() {
  return (dispatch, getState) => {
    if (shouldFetchCustomPostFields(getState())) {
      dispatch(requestCustomPostFields());
      return dispatch(fetchCustomPostFields());
    }
  };
}

export function reloadCustomPostFields() {
  return (dispatch, getState) => {
    return dispatch(fetchCustomPostFields());
  };
}

// Helpers

function shouldFetchCustomPostFields(state) {
  return !state.customPostFields;
}
